import React from 'react'
import { BoxProps } from '@chakra-ui/react'
import { Text } from './Text'
import { ShadeProps } from './utils/shade'

export const Label = (props: BoxProps & ShadeProps) => (
  <Text fontFamily="label" fontWeight="bold" fontSize="sm" shade={1} {...props} />
)
